// extracted by mini-css-extract-plugin
export default {"content":"style_content__FASkz","itemName":"style_itemName__2I8Xp"};